import { helper } from "./helper";
import { isAndroid, isAppx, isIos } from "./index";

/**
 * 解析uaserAgent
 */
export function parseUA() {
  var _window;
  if (isAppx) {
    var systemInfo = my.getSystemInfoSync();
    var _ref = systemInfo || {},
      pixelRatio = _ref.pixelRatio,
      windowWidth = _ref.windowWidth,
      windowHeight = _ref.windowHeight,
      language = _ref.language,
      _version = _ref.version,
      platform = _ref.platform,
      system = _ref.system,
      screenWidth = _ref.screenWidth,
      screenHeight = _ref.screenHeight,
      brand = _ref.brand,
      app = _ref.app,
      model = _ref.model;
    return {
      pixelRatio: pixelRatio,
      windowWidth: windowWidth,
      windowHeight: windowHeight,
      language: language,
      version: _version,
      platform: platform,
      system: system,
      screenWidth: screenWidth,
      screenHeight: screenHeight,
      brand: brand,
      app: app,
      model: model
    };
  }
  var UA = navigator.userAgent;
  var _getAppInfo = getAppInfo(UA),
    name = _getAppInfo.name,
    version = _getAppInfo.version;
  var systmInfo = {
    pixelRatio: ((_window = window) === null || _window === void 0 ? void 0 : _window.devicePixelRatio) || 1,
    windowWidth: document.documentElement.clientWidth,
    windowHeight: document.documentElement.clientHeight,
    language: getLang(UA),
    version: version,
    // APP 版本号
    platform: isAndroid ? 'Android' : isIos ? 'iOS' : 'PC',
    system: getOsVersion(UA),
    // 操作系统版本
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    brand: '',
    // 手机品牌
    model: '',
    // 手机型号
    app: name
  };
  return systmInfo;
}

/**
 * 从ua中解析语言
 * @param ua userAgent
 */
function getLang(ua) {
  var _ua$match$pop$toLocal, _ua$match, _ua$match$pop;
  var langFromAL = (navigator.language || navigator.browserLanguage).toLowerCase();
  if (langFromAL) return langFromAL;
  langFromAL = (_ua$match$pop$toLocal = (_ua$match = ua.match(/Language\/(.*)/i)) === null || _ua$match === void 0 ? void 0 : (_ua$match$pop = _ua$match.pop()) === null || _ua$match$pop === void 0 ? void 0 : _ua$match$pop.toLocaleLowerCase()) !== null && _ua$match$pop$toLocal !== void 0 ? _ua$match$pop$toLocal : 'en-us';
  return langFromAL;
}

/**
 * 获取浏览器所在机器操作系统版本
 * @param ua userAgent
 */
function getOsVersion(ua) {
  var tempArr = ua === null || ua === void 0 ? void 0 : ua.split(';');
  if (isIos) {
    var _tempArr$, _tempArr$$split$, _tempArr$$split$$spli, _tempArr$2, _tempArr$2$split$, _tempArr$2$split$$spl, _tempArr$2$split$$spl2;
    var device = (_tempArr$ = tempArr[1]) === null || _tempArr$ === void 0 ? void 0 : (_tempArr$$split$ = _tempArr$.split('OS')[0]) === null || _tempArr$$split$ === void 0 ? void 0 : (_tempArr$$split$$spli = _tempArr$$split$.split('CPU')[1]) === null || _tempArr$$split$$spli === void 0 ? void 0 : _tempArr$$split$$spli.replace(/ /g, '');
    var ver = (_tempArr$2 = tempArr[1]) === null || _tempArr$2 === void 0 ? void 0 : (_tempArr$2$split$ = _tempArr$2.split('OS')[1]) === null || _tempArr$2$split$ === void 0 ? void 0 : (_tempArr$2$split$$spl = _tempArr$2$split$.split('like')[0]) === null || _tempArr$2$split$$spl === void 0 ? void 0 : (_tempArr$2$split$$spl2 = _tempArr$2$split$$spl.replace(/_/g, '.')) === null || _tempArr$2$split$$spl2 === void 0 ? void 0 : _tempArr$2$split$$spl2.replace(/ /g, '');
    return "".concat(device, " ").concat(ver);
  } else if (isAndroid) {
    if (/Build/i.test(ua)) {
      var _tempArr$find, _tempArr$find$split, _tempArr$find$split$;
      var deviceType = (_tempArr$find = tempArr.find(function (item) {
        return /Build/i.test(item);
      })) === null || _tempArr$find === void 0 ? void 0 : (_tempArr$find$split = _tempArr$find.split('Build')) === null || _tempArr$find$split === void 0 ? void 0 : (_tempArr$find$split$ = _tempArr$find$split[0]) === null || _tempArr$find$split$ === void 0 ? void 0 : _tempArr$find$split$.replace(/ /g, '');
      return deviceType || '';
    } else {
      var _tempArr$3, _tempArr$3$split$;
      var deviceType2 = (_tempArr$3 = tempArr[2]) === null || _tempArr$3 === void 0 ? void 0 : (_tempArr$3$split$ = _tempArr$3.split(')')[0]) === null || _tempArr$3$split$ === void 0 ? void 0 : _tempArr$3$split$.replace(/ /g, '');
      return deviceType2;
    }
  } else {
    return ua;
  }
}

/**
 * 获取app名称及版本号
 * @param ua userAgent
 */
function getAppInfo(ua) {
  var result = {
    name: 'web',
    version: ''
  };
  if (/AliApp\(([\w-]+)\/([\d.]+)\)/i.test(ua)) {
    result = {
      name: String(RegExp.$1).toLowerCase(),
      version: RegExp.$2
    };
  }
  if (!isAppx) {
    helper.console.log({
      name: 'getAppInfo',
      result: result,
      ua: ua
    });
  }
  return result;
}